import React from "react";
import { formatDateReadable } from "../../utilities/helpers";
import { getInitials } from "../../utilities/helpers";
import { formatDateShift } from "../../utilities/helpers";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Drawer } from "@mui/material";
import DrawerHeader from "../helpers/DrawerHeader";
import DrawerFooterContainerSmall from "../helpers/DrawerFooterContainerSmall";
import ButtonGrayed from "../helpers/ButtonGrayed";
import ButtonFilled from "../helpers/ButtonFilled";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Tooltip from "@mui/material/Tooltip";
import ModalInfoCard from "../helpers/ModalInfoCard";
import {
  CalendarToday,
  Description,
  ChatBubbleOutline,
  Send,
  Edit,
  AccessTime,
  WorkOutline,
  FreeBreakfastOutlined,
  PlaceOutlined
} from '@mui/icons-material';

export default function ShiftPoolTableRow(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 475,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const shiftInfo = props.shiftInfo;

  let badgeText = "";
  if (shiftInfo?.badge === "is_pending_drop_by_user" && props.shiftPool) {
    badgeText = "Your Shift";
  } else if (shiftInfo?.badge === "is_pending_drop_by_user") {
    badgeText = "Drop Requested";
  } else if (
    shiftInfo?.badge === "is_trade_by_user_pending_employee_response"
  ) {
    badgeText = "Offered Trade";
  } else if (shiftInfo?.badge === "is_trade_by_user_pending_manager_response") {
    badgeText = "Offered Trade";
  } else if (shiftInfo?.badge === "is_trade_to_user_pending_self_response") {
    badgeText = "";
  } else if (shiftInfo?.badge === "is_trade_to_user_pending_manager_response") {
    badgeText = "";
  } else if (
    shiftInfo?.badge === "is_pending_pickup_by_user" &&
    props.shiftPool
  ) {
    badgeText = "Pickup Requested";
  } else {
    badgeText = "";
  }

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handlePickup = () => {
    props.create_pickup_request(props.shiftInfo.id, props.shiftInfo?.store?.id);
    setDrawerOpen(false);
  };


  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer transition-colors"
        onClick={toggleDrawer(true)}
      >
        <td className="whitespace-nowrap px-3 py-3.5 text-sm pl-6">
          <div className="flex items-center space-x-2">
            <div
              className={`${
                props.shiftInfo.status === "PENDING_DROP"
                  ? "text-rose-600"
                  : "text-emerald-600"
              }`}
            >
              {props.shiftInfo.status === "PENDING_DROP" ? (
                <RemoveCircleIcon sx={{ fontSize: 14 }} />
              ) : (
                <AddCircleIcon sx={{ fontSize: 14 }} />
              )}
            </div>
            <div
              className={`font-semibold text-sm ${
                props.shiftInfo.status === "PENDING_DROP"
                  ? "text-rose-700"
                  : "text-emerald-700"
              }`}
            >
              {props.shiftInfo.status === "PENDING_DROP"
                ? "Dropped by"
                : "Open shift"}
            </div>
          </div>
          {props.shiftInfo.status === "PENDING_DROP" && (
            <div className="flex items-center space-x-1.5 mt-0.5">
              <div className="w-5 h-5 bg-slate-200 rounded-full flex items-center justify-center">
                <p className="text-slate-600 text-[9px]">
                  {getInitials(props.shiftInfo.name)}
                </p>
              </div>
              <p className="text-slate-500 text-xs">{props.shiftInfo.name}</p>
            </div>
          )}
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
          <div className="font-semibold text-slate-900">
            {formatDateShift(props.shiftInfo.date)}
          </div>
          <div className="text-slate-500 text-xs mt-0.5">{props.shiftInfo.shift}</div>
        </td>
        {props.showLocationColumn && (
          <td className="whitespace-nowrap px-3 py-3.5 text-sm">
            <div className="flex items-center space-x-1.5 text-slate-600">
              <PlaceOutlined sx={{ fontSize: 15 }} />
              <span className="font-medium">
                {props.shiftInfo.location || props.shiftInfo?.store?.store_name || "—"}
              </span>
            </div>
          </td>
        )}
        <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
          {props.shiftInfo.station
            ? props.shiftInfo.station?.name
            : props.shiftInfo.role
            ? props.shiftInfo.role
            : props.shiftInfo.roleType}
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
          {(props.shiftInfo?.note || props.shiftInfo?.employee_drop_note) &&
            <Tooltip title={
              <>
                {props.shiftInfo?.note && (
                  <div>Shift note: {props.shiftInfo.note}</div>
                )}
                {props.shiftInfo?.employee_drop_note && (
                  <div>Employee drop note: {props.shiftInfo.employee_drop_note}</div>
                )}
              </>
            }>
              <span className="text-violet-600 cursor-pointer">
                <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
              </span>
            </Tooltip>
          }
        </td>
        <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
          {badgeText ? (
            <div className="flex justify-end">
              <div className="bg-amber-50 border border-amber-200 px-2.5 py-0.5 rounded-full flex items-center justify-center space-x-1">
                <WarningAmberIcon sx={{ fontSize: 14, color: "#b45309" }} />
                <p className="text-amber-700 text-xs">{badgeText}</p>
              </div>
            </div>
          ) : (
            <div className="flex justify-end">
              <div></div>
            </div>
          )}
        </td>
      </tr>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className="w-[450px] h-full relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader title="Request Pickup" onClose={toggleDrawer(false)} />
            {badgeText && (
              <div className="w-full my-6 px-6">
                <div className="flex flex-row items-center justify-between bg-amber-50 border border-amber-200 px-4 py-3 rounded-xl">
                  <div className="flex flex-row items-center space-x-2 text-amber-700">
                    <WarningAmberIcon sx={{ fontSize: 20 }} />
                    <p className="text-amber-700 text-sm">
                      {badgeText}
                    </p>
                  </div>
                  {badgeText === "Pickup Requested" && (
                    <div
                      className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 rounded-lg cursor-pointer transition-colors"
                      onClick={() =>
                        props.rescind_pickup_shift(
                          props.shiftInfo.id,
                          props.shiftInfo?.store?.id
                        )
                      }
                    >
                      <p className="text-white text-sm">Cancel</p>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="w-full px-6">

              <div className="mb-4 flex items-center space-x-4">
                <div className="flex-1">
                  <ModalInfoCard
                    icon={CalendarToday}
                    title="Date"
                    value={formatDateReadable(props.shiftInfo?.date)}
                  />
                </div>
                <div className="flex-1">
                  <ModalInfoCard
                    icon={AccessTime}
                    title="Time"
                    value={props.shiftInfo?.shift}
                  />
                </div>
              </div>

              <div className="mb-4 flex items-center space-x-4">
                <div className="flex-1">
                  <ModalInfoCard
                    icon={FreeBreakfastOutlined}
                    title="Break"
                    value={props.shiftInfo?.break_formatted}
                  />
                </div>
                <div className="flex-1">
                  <ModalInfoCard
                    icon={WorkOutline}
                    title="Role"
                    value={props.shiftInfo?.station
                      ? props.shiftInfo?.station?.name
                      : props.shiftInfo?.role
                      ? props.shiftInfo?.role
                      : props.shiftInfo?.roleType}
                  />
                </div>
              </div>

              {props.shiftInfo?.note &&
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Shift Note"
                    value={props.shiftInfo?.note}
                  />
                </div>
              }

              {props.shiftInfo?.employee_drop_note &&
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Employee Drop Note"
                    value={props.shiftInfo?.employee_drop_note}
                  />
                </div>
              }

              {props.shiftInfo.location && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={PlaceOutlined}
                    title="Location"
                    value={props.shiftInfo?.location}
                  />
                </div>
              )}

              {props.shiftInfo.status === "PENDING_DROP" &&
                badgeText !== "Your Shift" ? (
                  <div className="w-full mt-8 pb-5">
                    <div className="flex flex-row items-center space-x-2">
                      <div className="text-rose-600">
                        <RemoveCircleIcon />
                      </div>
                      <p className="text-rose-800 text-xl">Dropped by</p>
                      <div className="pl-3">
                        <p className="text-slate-500 text-xl">
                          {props.shiftInfo.name}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : props.shiftInfo.status === "AVAILABLE" ? (
                  <div className="w-full mt-8 pb-5">
                    <div className="flex flex-row items-center space-x-2">
                      <div className="text-emerald-600">
                        <AddCircleIcon />
                      </div>
                      <p className="text-emerald-800 text-xl">Open shift</p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            <div className="w-full h-[100px]"></div>
            <DrawerFooterContainerSmall>
              {badgeText ? (
                <ButtonGrayed text="Pickup" />
              ) : (
                <ButtonFilled text="Pickup" onClick={() => handlePickup()} />
              )}
            </DrawerFooterContainerSmall>
          </div>
        </div>
      </Drawer>
    </>
  );
}
